<template>
    <nav aria-label="You are here:" role="navigation">
        <ul class="c-breadcrumbs">
            <li v-for="link in links"><router-link :to="link.route">{{link.title}}</router-link></li>
            <li>
                <span class="show-for-sr">Current: </span> {{title}}
            </li>
        </ul>
    </nav>
</template>

<script>

export default {
    computed: {
        title() {
            return typeof this.$route.meta.title == 'function' ?
                    this.$route.meta.title(this.$route) : this.$route.meta.title;
        },
        links() {
            let output = [];

            if ( this.$route.meta && this.$route.meta.breadcrumb ){

                this.$route.meta.breadcrumb.forEach( (name) => {
                    let path = this.$router.resolve({
                      name: name,
                      params: { id: this.$route.params.id },
                    });

                    output.push({
                        title: path.route.meta.title(path.route),
                        route: path.route
                    });
                });
            }

            return output;
        }
    }
}
</script>
